import City, { type CityData } from './city'

export default class Category {
  _id: string
  name: string
  slug: string
  is_city: boolean
  hidden: boolean
  city: City

  constructor(data: Record<string, unknown>) {
    this._id = (data._id as string) ?? ''
    this.name = (data.name as string) ?? ''
    this.slug = (data.slug as string) ?? ''
    this.is_city = (data.is_city as boolean) ?? false
    this.hidden = (data.hidden as boolean) ?? false
    this.city = (data.city ? new City(data.city as CityData) : undefined) as City
  }
}
